import type { ComponentType } from 'react'
import RestaurantIcon from '@mui/icons-material/Restaurant'
import LocalCafeIcon from '@mui/icons-material/LocalCafe'
import ParkIcon from '@mui/icons-material/Park'
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag'
import type { PlaceCategory } from '@cobu/types'
import { Strings } from '../../constants/Strings'

export interface CategoryMeta {
  icon: ComponentType<any>
  color: string
  backgroundColor: string
}

/** The four fixed Places categories (PRD §7). Labels are localized — see the getters below. */
export const CATEGORY_META: Record<PlaceCategory, CategoryMeta> = {
  food: {
    icon: RestaurantIcon,
    color: '$color',
    backgroundColor: '$background',
  },
  coffee: {
    icon: LocalCafeIcon,
    color: '$color',
    backgroundColor: '$background',
  },
  outdoor: {
    icon: ParkIcon,
    color: '$color',
    backgroundColor: '$background',
  },
  shop: {
    icon: ShoppingBagIcon,
    color: '$color',
    backgroundColor: '$background',
  },
}

export const CATEGORY_ORDER: PlaceCategory[] = ['food', 'coffee', 'outdoor', 'shop']

/** Full category label ("Food & drink"), read live so it follows the active language. */
export const getCategoryLabel = (category: PlaceCategory): string =>
  Strings.get().places.categories[category]

/** Short label for the filter pills ("Food"). */
export const getCategoryShortLabel = (category: PlaceCategory): string =>
  Strings.get().places.categoriesShort[category]
